import axios from "axios";

export const getShipmentApi = async (
  lang,
  cookies,
  setShipment,
  setMessageResponse,
  setData
) => {
  const token = cookies.__t0ken_amar_management;

  let config = {
    method: "get",
    url: `${process.env.REACT_APP_API}/shipping-rate`,
    headers: {
      lan: lang,
      Authorization: `Bearer ${token}`,
    },

    timeout: 15000,
  };

  try {
    const res = await axios(config);
    setShipment((prev) => ({ ...prev, data: res.data.data, loader: false }));
    setData((prev) => ({ ...prev, dollar: res.data.data.dollar  }));
  } catch (error) {
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
    }
  }
};
